import React, { useEffect, useState } from 'react';
import { Col, Input, Row, Select } from 'antd';
import { useIntl } from 'react-intl';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Country } from 'entities/countries/model/types';

export type PhoneInputState = {
  countryCode: number;
  phoneNumber: string;
  haveErrors: boolean;
};

type PhoneInputProps = {
  countries: Country[];
  onChange: (state: PhoneInputState) => unknown;
};

const PhoneInput: React.FC<PhoneInputProps> = ({ countries, onChange }) => {
  const { formatMessage: t } = useIntl();

  const [state, setState] = useState<PhoneInputState>({
    countryCode: countries[0]?.id || -1,
    phoneNumber: '',
    haveErrors: true,
  });

  const [errors, setErrors] = useState({
    country: '',
    phone: ''
  });

  const validate = () => {
    let countryError = '';
    let phoneError = '';

    const country = countries.find((c) => c.id === state.countryCode);
    if (!country) {
      countryError = t({ id: 'schemas.validation.phone.country.required' });
    }

    const phoneNumber = parsePhoneNumberFromString(
      `+${country?.phoneCode || ''}${state.phoneNumber}`
    );

    if (!phoneNumber || !phoneNumber.isValid()) {
      phoneError = t({ id: 'schemas.validation.phone.invalid' });
    }

    const haveErrors = !!countryError || !!phoneError;

    setErrors({ country: countryError, phone: phoneError });
    onChange({ ...state, haveErrors });
  };

  useEffect(() => {
    validate();
  }, [state.countryCode, state.phoneNumber]);

  return (
    <Row gutter={8}>
      <Col span={10}>
        <Select
          value={state.countryCode}
          onChange={(v) =>
            setState((old) => ({ ...old, countryCode: v }))
          }
          style={{ height: 55 }}
          showSearch
          optionLabelProp="label"
        >
          {countries.map((country) => (
            <Select.Option
              key={country.id}
              value={country.id}
              label={`+${country.phoneCode}`}
            >
              +{country.phoneCode} {country.name}
            </Select.Option>
          ))}
        </Select>
        {/*{errors.phone && (*/}
        {/*  <div style={{ color: '#ff4d4f', marginTop: 4 }}>{errors.country}</div>*/}
        {/*)}*/}
      </Col>

      <Col span={14}>
        <Input
          style={{ height: 55 }}
          placeholder="000-00-00"
          value={state.phoneNumber}
          onChange={(e) =>
            setState((old) => ({ ...old, phoneNumber: e.target.value }))
          }
        />
        {errors.country && (
          <div style={{ color: '#ff4d4f', marginTop: 4, paddingLeft: 50}}>{errors.phone}</div>
        )}
      </Col>
    </Row>
  );
};

export default PhoneInput;
